/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import type { TokenV2ResponseChallengeList } from './TokenV2ResponseChallengeList';
import {
    instanceOfTokenV2ResponseChallengeList,
    TokenV2ResponseChallengeListFromJSON,
    TokenV2ResponseChallengeListFromJSONTyped,
    TokenV2ResponseChallengeListToJSON,
} from './TokenV2ResponseChallengeList';
import type { TokenV2ResponseToken } from './TokenV2ResponseToken';
import {
    instanceOfTokenV2ResponseToken,
    TokenV2ResponseTokenFromJSON,
    TokenV2ResponseTokenFromJSONTyped,
    TokenV2ResponseTokenToJSON,
} from './TokenV2ResponseToken';

/**
 * @type TokenV2Response
 * 
 * @export
 */
export type TokenV2Response = { type: 'challenge_list' } & TokenV2ResponseChallengeList | { type: 'token' } & TokenV2ResponseToken;

export function TokenV2ResponseFromJSON(json: any): TokenV2Response {
    return TokenV2ResponseFromJSONTyped(json, false);
}

export function TokenV2ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): TokenV2Response {
    if (json == null) {
        return json;
    }
    switch (json['type']) {
        case 'challenge_list':
            return Object.assign({}, TokenV2ResponseChallengeListFromJSONTyped(json, true), { type: 'challenge_list' } as const);
        case 'token':
            return Object.assign({}, TokenV2ResponseTokenFromJSONTyped(json, true), { type: 'token' } as const);
        default:
            return json;
    }
}

export function TokenV2ResponseToJSON(json: any): any {
    return TokenV2ResponseToJSONTyped(json, false);
}

export function TokenV2ResponseToJSONTyped(value?: TokenV2Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    switch (value['type']) {
        case 'challenge_list':
            return Object.assign({}, TokenV2ResponseChallengeListToJSON(value), { type: 'challenge_list' } as const);
        case 'token':
            return Object.assign({}, TokenV2ResponseTokenToJSON(value), { type: 'token' } as const);
        default:
            return value;
    }
}

